import React, { useMemo, useCallback } from 'react'
import { Template } from 'devextreme-react/core/template'
import { exportDataGrid } from 'devextreme/excel_exporter'
import excelJS from 'exceljs'
import saveAs from 'file-saver'
import { useTranslation } from 'react-i18next'

import ItemActions from 'components/SectionHandler/ItemActions'
import { Export as ExportIco } from 'media/icons'

export default props => {
	const { withSearch, excelExport, ref, toolBarActions = [] } = props
	const [t] = useTranslation()

	const templates = Array.isArray(props.templates) ? [...props.templates] : []
	const renderActions = useMemo(() => !!excelExport, [excelExport])
	const onToolbarPreparing = e => {
		if(props.onToolbarPreparing) {
			props.onToolbarPreparing(e)
		}
		if(withSearch) {
			e.toolbarOptions.items.unshift({
				location: 'before',
				template: 'search'
			})
		}
		if(renderActions) {
			e.toolbarOptions.items.push({
				location: 'after',
				template: 'actions'
			})
		}
	}

	const handleExport = useCallback(e => {
		const workbook = new excelJS.Workbook()
		const worksheet = workbook.addWorksheet('Sheet 1')

		exportDataGrid({
			component: ref.current.instance,
			worksheet: worksheet,
			autoFilterEnabled: true
		}).then(() => {
			workbook.xlsx.writeBuffer().then(buffer => {
				saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx')
			})
		})
		e.cancel = true
	}, [ref])

	const searchRender = useCallback(() => (
		<input
			type='text'
			onChange={e => {
				const val = e.target.value
				ref.current.instance.searchByText(val)
			}}
			placeholder={t('common.strings.search')}
		/>
	), [ref])
	const actionsRender = () => {
		const actions = [...toolBarActions]
		if(excelExport) {
			actions.push({
				label: t('common.strings.excel_export'),
				action: handleExport,
				Icon: ExportIco
			})
		}
		return actions.length ? <ItemActions actions={actions} /> : null
	}

	if(withSearch) {
		templates.push(<Template key='search' name='search' render={searchRender} />)
	}
	if(renderActions) {
		templates.push(<Template key='actions' name='actions' render={actionsRender} />)
	}

	return {
		onToolbarPreparing,
		templates
	}
}
